import {on} from 'delegated-events';

on('click', '.show_on_click', (e) => {
  let el = e.target
  while(el = el.nextElementSibling)
    el.classList.toggle('out')
});
